import { RefObject } from 'react'
import { VisibleMessage, MessageAnimType } from '../Messages'
import { Message } from '~/service/chatConn/types'
import { getHeight, getWidth } from '~/utils/DOM'

export const getPrevMsg = (visibleMessages: VisibleMessage[]) => {
  return visibleMessages[visibleMessages.length - 2]
}

export const getElByUid = (ref: RefObject<HTMLDivElement>, uid: string) => {
  if (!ref.current) {
    return undefined
  }

  return [...ref.current.children].find(
    m => (m as HTMLDivElement).dataset.uid == uid
  )
}

export const getMessage = (messages: Message[], uid: string) =>
  messages.find(m => m.uid == uid)

export const getMsgByType = (
  visibleMessages: VisibleMessage[],
  type: MessageAnimType
) => {
  return visibleMessages.find(m => m.animType == type)
}

export const getWrapperPaddingBottom = (ref: RefObject<HTMLDivElement>) => {
  if (!ref.current) {
    return 0
  }

  const wrapperStyle = window.getComputedStyle(ref.current)

  return parseInt(`${wrapperStyle.paddingBottom}`)
}

export const getMessageSize = (
  ref: RefObject<HTMLDivElement>,
  uid: string,
  withMargin: boolean = true
) => {
  const el = getElByUid(ref, uid) as HTMLDivElement

  return [getWidth(el, false), getHeight(el, withMargin)]
}
